// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as $ from "jquery";
import BaoDialogViewModel from "./../factories/bao-dialog";
// bao migrate - module not found: import registerModule from "modules/register-module";
import baoDialog from "./../factories/bao-dialog";
function RegisterViewModel(Model) {
    var self = this;
    self.IsLoading = ko.observable();
    self.LanguageSymbol = ko.observable();
    self.CaptionEmail = ko.observable();
    self.CaptionSalutation = ko.observable();
    self.CaptionLastname = ko.observable();
    self.CaptionFirstname = ko.observable();
    self.CaptionTelephone = ko.observable();
    self.CaptionCompany = ko.observable();
    self.CaptionRemark = ko.observable();
    self.CaptionTermsOfService = ko.observable();
    self.CaptionLanguage = ko.observable();
    self.CaptionOk = ko.observable();
    self.CaptionCancel = ko.observable();
    self.CaptionDialogFillMandatoryFields = ko.observable();
    self.SalutationCollection = ko.observableArray([]);
    self.Dialog = new baoDialog();
    self.LanguageSymbol.subscribe(function () {
        Bao.Session.GetCaptions("Register", self.LanguageSymbol()).then(function (captions) {
            self.CaptionSalutation(captions.lblSalutation);
            self.CaptionEmail(captions.lblEMail);
            self.CaptionLastname(captions.lblLastname);
            self.CaptionFirstname(captions.lblFirstname);
            self.CaptionTelephone(captions.lblTelephone);
            self.CaptionCompany(captions.lblCompany);
            self.CaptionRemark(captions.lblRemark);
            self.CaptionTermsOfService(captions.lblTermsOfService);
            self.CaptionLanguage(captions.lblLanguage);
            self.CaptionOk(captions.lblOk);
            self.CaptionCancel(captions.lblCancel);
            self.CaptionDialogFillMandatoryFields(captions.lblDialogFillMandatoryFields);
            var okButton = new baoDialog.ButtonFactory();
            okButton.Title(captions.lblDialogOk);
            okButton.Click = function () {
                self.Dialog.Close();
            };
            self.Dialog.Width("400px");
            self.Dialog.Title(Bao.Session.ApplicationName());
            self.Dialog.Template(self.CaptionDialogFillMandatoryFields());
            self.Dialog.Buttons([okButton]);
        });
        self.LoadSalutationCollection();
    });
    self.UserFocus = function () { };
    self.RequestCancel = function () {
        window.location.href = window.absolutePath + "Login";
    };
    self.CompleteCheck = function () {
        var def = $.Deferred();
        self.IsLoading(true);
        Bao.post("Register/ValidateRegister", JSON.stringify({
            registerModel: ko.map.toJS(self)
        }), function (value) {
            self.IsLoading(false);
            if (value.IsValid) {
                def.resolve(true);
            }
            else {
                self.Dialog.Template(value.ValidationMessage);
                self.Dialog.Open();
                def.resolve(false);
            }
        });
        return def.promise();
    };
    self.RequestRegister = function () {
        var def = $.Deferred();
        self.CompleteCheck().then(function (value) {
            if (value) {
                self.IsLoading(true);
                Bao.post("Register/RequestRegister", JSON.stringify({
                    registerModel: ko.map.toJS(self),
                    languageSymbol: self.LanguageSymbol()
                }), function (value) {
                    def.resolve();
                    window.location = value.Url;
                });
            }
            else {
                def.resolve();
            }
        });
        return def.promise();
    };
    self.LoadSalutationCollection = function () {
        return Bao.post("Register/GetSalutationCollection", function (result) {
            self.SalutationCollection(result);
        });
    };
    self.init = function () {
        return Bao.post("Register/GetRegisterModel", function (result) {
            ko.map.fromJS(result, self);
            self.LanguageSymbol(window.LanguageSymbol);
        });
    };
    self.FormVisible = ko.observable(true);
    return self;
}
export default RegisterViewModel;